import React from "react";
import { useSearchParams } from "react-router-dom";
import TransportsPage from "./TransportsPage";
import LoadsPage from "./LoadsPage";

/** «Поиск» — transports and loads on one page (business round 2, iTruck_Search_Unified). */
export default function SearchPage() {
  const [params] = useSearchParams();
  const mode = params.get("mode") === "loads" ? "loads" : "transport";
  return mode === "loads" ? <LoadsPage key="loads" /> : <TransportsPage key="transport" />;
}
